import { render, staticRenderFns } from "./Servicio.vue?vue&type=template&id=4b09f278&scoped=true&"
import script from "./Servicio.vue?vue&type=script&lang=js&"
export * from "./Servicio.vue?vue&type=script&lang=js&"
import style0 from "./Servicio.vue?vue&type=style&index=0&id=4b09f278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09f278",
  null
  
)

export default component.exports